import React from "react";
import PropTypes from "prop-types";
import File from "../../../icons/File";
import Btn from "../../../atoms/Btn";

function ContentButton({ onSelect, isActive, className, size }) {
  const colorClass = isActive
    ? "tw-text-blue-500"
    : "tw-text-blueGray-700 tw-opacity-60 hover:tw-opacity-100";

  return (
    <div
      className={`tw-text-center tw-flex tw-items-center tw-relative ${colorClass}`}
    >
      <Btn onSubmit={onSelect} className="tw-flex tw-items-center">
        <div
          className={`${className} tw-flex tw-items-center tw-justify-center tw-relative tw-transition-colors tw-duration-300`}
        >
          <File className="tw-fill-current" size={size} />
        </div>
        <div>Content</div>
      </Btn>
      <div className="tw-w-0.5" />
    </div>
  );
}

ContentButton.propTypes = {
  isActive: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
};

ContentButton.defaultProps = {
  isActive: false,
  className: "tw-w-6 tw-h-6",
  size: 16,
};

export default React.memo(ContentButton);
